import { toast } from 'react-toastify';

// Create a queue to track toast messages
const toastQueue = [];

const showToast = (message, type) => {
  // Check if the same message is already in the queue
  if (toastQueue.includes(message)) {
    return;
  }

  // Add the message to the queue
  toastQueue.push(message);

  // Display the toast
  toast[type](message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    onClose: () => {
      // Remove the message from the queue when the toast is closed
      const index = toastQueue.indexOf(message);
      if (index !== -1) {
        toastQueue.splice(index, 1);
      }
    },
  });
};

export const showToastSuccess = (message) => {
  showToast(message, "success");
};

export const showToastError = (message) => {
  showToast(message, "error");
};

export const showToastInfo = (message) => {
  showToast(message, "info");
};

export const showToastWarning = (message) => {
  showToast(message, "warning");
};
